import { createPortal } from 'react-dom';
import { makeStyles } from 'tss-react/mui';
import { keyframes } from 'tss-react';
import { useIsFloatingMenuVisible } from '../../../../Components/FloatingBottomArea/FloatingMenu';

interface IProps {
  size?: number;
  testId?: string;
  overlay?: boolean;
}
const animation1 = keyframes({
  '0%': {
    transform: 'translate(-1em, 4em)',
  },
  '100%': {
    transform: 'translate(0, 0)',
  },
});
const animation2 = keyframes({
  '0%': {
    transform: 'translate(0, 0)',
  },
  '100%': {
    transform: 'translate(1.2em, 0)',
  },
});
const animation3 = keyframes({
  '0%': {
    transform: 'translate(0, 0)',
  },
  '100%': {
    transform: 'translate(1em, 4em)',
  },
});
const useStyles = makeStyles()(theme => ({
  overlayContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: theme.zIndex.fab + 1,
  },
  overlay: {
    top: theme.spacing(0),
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loaderWrapper: {
    fontSize: '12px !important',
  },
  loader: {
    position: 'absolute',
    width: '5.4em',
    height: '4em',
    left: 'calc(50% - 2.7em)',
    top: 'calc(50% - 1.8em)',
    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 50% 30%, 0 100% )',
  },
  bar: {
    display: 'block',
    position: 'absolute',
    top: 0,
    width: '0.85em',
    height: '100%',
    borderRadius: '0.35em 0.35em 0 0',
    background: theme.customProperties.Legend.orange.full,
  },
  bar1: {
    left: '0.44em',
    animationName: `${animation1}`,
    animationDuration: '1.2s',
    animationIterationCount: 'infinite',
  },

  bar2: {
    left: '0.44em',
    animationName: `${animation2}`,
    animationDuration: '1.2s',
    animationIterationCount: 'infinite',
  },
  bar3: {
    left: '1.68em',
    animationName: `${animation2}`,
    animationDuration: '1.2s',
    animationIterationCount: 'infinite',
  },
  bar4: {
    left: '2.92em',
    animationName: `${animation2}`,
    animationDuration: '1.2s',
    animationIterationCount: 'infinite',
  },
  bar5: {
    left: '4.16em',
    animationName: `${animation3}`,
    animationDuration: '1.2s',
    animationIterationCount: 'infinite',
  },
}));

// '@keyframes lds-ellipsis1': {
//   '0%': {
//     transform: 'translate(-1em, 4em)',
//   },
//   '100%': {
//     transform: 'translate(0, 0)',
//   },
// },
// '@keyframes lds-ellipsis2': {
//   '0%': {
//     transform: 'translate(0, 0)',
//   },
//   '100%': {
//     transform: 'translate(1.2em, 0)',
//   },
// },

// '@keyframes lds-ellipsis3': {
//   '0%': {
//     transform: 'translate(0, 0)',
//   },
//   '100%': {
//     transform: 'translate(1em, 4em)',
//   },
// },
export const EDAvenyProgressMedium = (props: IProps) => {
  const { classes, cx } = useStyles();
  const isFloatingMenuVisible = useIsFloatingMenuVisible();
  const size: string = props.size ? props.size / 4 + 'px' : '12px';
  const progressContent = (
    <div
      className={classes.loaderWrapper}
      style={{ fontSize: size }}
      data-testid={props.testId}
    >
      <div className={cx(classes.loader)}>
        <span className={cx(classes.bar, classes.bar1)}></span>
        <span className={cx(classes.bar, classes.bar2)}></span>
        <span className={cx(classes.bar, classes.bar3)}></span>
        <span className={cx(classes.bar, classes.bar4)}></span>
        <span className={cx(classes.bar, classes.bar5)}></span>
      </div>
    </div>
  );

  if (props.overlay) {
    const overlayElement = (
      <div className={classes.overlayContainer}>{progressContent}</div>
    );
    // If the floating menu is visible, we need to render the overlay in a portal to ensure it appears above the menu. Otherwise, we can render it directly.
    return isFloatingMenuVisible
      ? createPortal(overlayElement, document.body)
      : overlayElement;
  }

  return progressContent;
};

export default EDAvenyProgressMedium;
